import DeltaWifiFooter from './DeltaWifiFooter';

export default DeltaWifiFooter;
